import { MainRoutePath } from 'applications/GSP/shared/constants/router/routePaths';
import { UserRole } from 'applications/GSP/shared/types';

export const ROLE_PERMISSIONS_BY_MAIN_ROUTE: Readonly<
  Record<string, UserRole[]>
> = {
  [MainRoutePath.Dashboard]: [
    UserRole.Admin,
    UserRole.Staff,
    UserRole.Parent,
    UserRole.Student,
  ],
  [MainRoutePath.Calendar]: [
    UserRole.Admin,
    UserRole.Staff,
    UserRole.Parent,
    UserRole.Student,
  ],
  [MainRoutePath.Subjects]: [
    UserRole.Admin,
    UserRole.Staff,
    UserRole.Parent,
    UserRole.Student,
  ],
  [MainRoutePath.Progress]: [
    UserRole.Admin,
    UserRole.Staff,
    UserRole.Parent,
    UserRole.Student,
  ],
  [MainRoutePath.ParentHelper]: [UserRole.Parent],
  [MainRoutePath.SchoolLinks]: [
    UserRole.Admin,
    UserRole.Staff,
    UserRole.Parent,
    UserRole.Student,
  ],
};
